import styled from 'styled-components'

export const LabelStyled = styled.label`
  color: ${(props) => props.theme.labelTextColour};
  font-size: ${(props) => props.theme.labelFontSize};
  font-weight: ${(props) => props.theme.labelFontWeight};
  font-family: ${(props) => props.theme.labelFontFamily};
  text-align: left;
  display: block;
  line-height: 100%;
`
